// extracted by mini-css-extract-plugin
module.exports = {"dont-break-out":"ProductDetail_dont-break-out__SBxbO","preserve-new-line":"ProductDetail_preserve-new-line__rnj_A"};